module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/your-design-here-rotator-54c7c47aef89e0368ed97e1732eb1652.webp";